import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "loremployee",
  inputs: [
    {
      name: "employee_name",
      label: "Name of the Employee",
      placeholder: "Aryan Sharma",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "role",
      label: "Role",
      placeholder: "Software Developer",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "time_duration",
      label: "Time Duration",
      placeholder: "6 years",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "skills",
      label: "Skills",
      placeholder: "quick learner, technical, creative",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 200,
    },
    {
      name: "attributes",
      label: "Attributes",
      placeholder:
        "Conflict resolution, Communication skills., Willing to learn and ask questions.",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
    },
    {
      name: "reason",
      label: "Reason For Recommendation",
      placeholder: "Dedication, positive demeanor",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 300,
    },
    {
      name: "recommender_detail",
      label: "Recommender's Contact Info",
      placeholder: "shallinveer@tootler.ai",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 300,
    },
  ],
};

export default formFields;
